/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRecoveringStockDto } from '../../models/create-recovering-stock-dto';
import { RecoveringStock } from '../../models/recovering-stock';

export interface CreateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params {
      body: CreateRecoveringStockDto
}

export function createOneBaseMgmtRecoveringStockControllerRecoveringStock(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStock>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtRecoveringStockControllerRecoveringStock.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringStock>;
    })
  );
}

createOneBaseMgmtRecoveringStockControllerRecoveringStock.PATH = '/api/mgmt/recovering-stock';
